import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import api from "@/lib/api";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import BookingWizard from "@/components/BookingWizard";
import MyBookings from "@/components/MyBookings";
import Footer from "@/components/Footer";
import BarberPage from "@/components/BarberPage";

function Home() {
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  useEffect(() => {
    api
      .get("/services")
      .then((r) => setServices(r.data))
      .catch(() => {});
  }, []);

  const handleToggleService = (id) => {
    const willSelect = !selectedServices.includes(id);
    setSelectedServices((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
    if (willSelect) {
      document.getElementById("agendar")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0e]">
      <Header />
      <Hero />
      <Services services={services} selected={selectedServices} onToggle={handleToggleService} />
      <BookingWizard
        services={services}
        serviceIds={selectedServices}
        setServiceIds={setSelectedServices}
      />
      <MyBookings />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/barbeiro" element={<BarberPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
